import { OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import themes from './theme-map';
var ThemeColorComponent = /** @class */ (function () {
    function ThemeColorComponent() {
    }
    ThemeColorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.updateFontInputs(this.themeControl.value);
        this.themeControl.valueChanges.subscribe(function (themeName) {
            _this.updateFontInputs(themeName);
        });
    };
    Object.defineProperty(ThemeColorComponent.prototype, "themeControl", {
        get: function () {
            return this.popupSettings.controls.theme;
        },
        enumerable: true,
        configurable: true
    });
    ThemeColorComponent.prototype.updateFontInputs = function (themeName) {
        var theme = themes[themeName];
        this.popupSettings.controls.customColor.setValue(theme.backgroundColor);
        this.popupSettings.controls.customFontColor.setValue(theme.fontColor);
    };
    return ThemeColorComponent;
}());
export { ThemeColorComponent };
